<template>
    <app-layout>
        <template #header>
            <h3>RMA #{{ returnShipment.id }} - {{ returnShipment.status }}</h3>
            <flash-messages />
        </template>

        <div class="bg-white p-3">
            <div class="m-1">
                <a :href="route('mtd.return.index')"><i class="fa-solid fa-arrow-left"></i> Back to Returns</a>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-auto vl-parent">
                    <div>
                        <p class="text-secondary font-italic">Returns must be like new condition and in orignal packaging
                        </p>
                    </div>
                    <div>
                        <p class="font-weight-bold">Please ship the indicated items. Warranties and Credits
                            will be issued when items are processed.</p>
                    </div>
                    <table class="w-100" style="border-collapse: collapse;">
                        <ReturnShipment :returnShipment="returnShipment" submitted="true"
                            @printPackingSlip="openPrintPackingSlip" />
                        <tr>
                            <td colspan="4">
                                <div class="pb-3"></div>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </app-layout>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="print" />
    </teleport>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import ReturnShipment from '@/Components/Returns/ReturnShipment'
import PrintModal from '@/Components/Modals/PrintModal.vue';

export default {
    components: {
        AppLayout,
        FlashMessages,
        ReturnShipment,
        PrintModal,
    },
    props: {
        returnShipment: Object,
    },
    data() {
        return {
            printUrl: null,
        }
    },
    methods: {
        openPrintPackingSlip(returnShipmentId) {
            this.printReport = 'mtd.return.packingslip'
            this.printingReturnShipmentId = returnShipmentId
            this.openPrintDialog();
        },
        openPrintDialog() {
            this.setPrintUrl(0);
            $('#PrintModal').modal('show');
        },
        print() {
            this.setPrintUrl(1);
        },
        setPrintUrl(print) {
            this.printUrl = this.route(this.printReport, { returnShipment: this.printingReturnShipmentId, print: print });
        },
    }
}
</script>

<style>
.gallery-thumbnail img {
    width: 120px;
}

.qty-text {
    max-width: 100px;
}
</style>